import { observer } from 'mobx-react-lite';
import { logUsage } from 'owa-analytics';
import { getNumDaysInDayRange } from 'owa-calendar-surface-options-utils';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { processDateRangeChange } from 'owa-calendar-surface-view-store';
import { Timestrip } from 'owa-timestrip';
import { isFeatureEnabled } from 'owa-feature-flags';
import * as React from 'react';

import styles from './SurfaceTimestrip.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export default observer(function SurfaceTimestrip() {
    const surfaceStore = getSurfaceStore();
    const menuIconClassName = classNames(
        styles.menuIcon,
        isFeatureEnabled('mon-tri-commandbarStyling') && styles.miniChevron
    );
    const showShowSurfaceNavBar = isFeatureEnabled('mon-ribbon');

    return (
        <Timestrip
            applySelectionStyling={true}
            className={showShowSurfaceNavBar ? styles.timeUnderCommanding : styles.time}
            dateRange={surfaceStore.dateRange}
            dateRangeType={surfaceStore.dateRangeType}
            weekStartDay={surfaceStore.userOptions.weekStartDay}
            showWeekNumbers={surfaceStore.userOptions.showWeekNumbers}
            firstWeekOfYear={surfaceStore.userOptions.firstWeekOfYear}
            workDays={surfaceStore.userOptions.workDays}
            numDaysInDayRange={getNumDaysInDayRange()}
            useWeekDay={false}
            onDateRangeChange={processDateRangeChange}
            onDayPickerDateSelected={onDayPickerDateSelected}
            selectionClassName={showShowSurfaceNavBar && styles.timeSelection}
            buttonLabelClassName={showShowSurfaceNavBar && styles.timeLabelText}
            menuIconClassName={menuIconClassName}
        />
    );
});

function onDayPickerDateSelected(): void {
    logUsage('SurfaceTimestripCalSelectDate');
}
